import compareFixedBtn from "../modules/compareFixedBtn.js";

(function ($) {
    const init = async function () {
        window.$ = jQuery;

        const escapeHtml = value => $('<div>').text(value).html();
        const translatedHtml = value => window.translates[value]
            ? window.translateByKey(value)
            : escapeHtml(value);

        compareFixedBtn.init();

        window.exchangesFilteredItems = exchanges.map(exchange => exchange.ID);

        window.exchangesPage = 1;

        function setOrderNumbers(){
            $('[data-sort-number]:not(:hidden)').each((index, element) => {
                $(element).text(exchangesPerPage * (window.exchangesPage - 1) + index + 1)

                const btn = $(element).closest('[data-exchange-id]').find('.widget-exchange-info-2__button')[0];
                $(btn).hide();

                if(index <= 2) {
                    $(btn).show();
                }
            })
        }

        function setMetaCounts() {
            const $show = $('[data-pagination-show]');
            const $total = $('[data-pagination-total]');
            const $totalCount = $('[data-pagination-total-count]');
            const $totalCountText = $('[data-pagination-total-count-text]');

            const totalCount = window.exchangesFilteredItems.length;
            const showCount = totalCount <= window.exchangesPage * exchangesPerPage ? totalCount : window.exchangesPage * exchangesPerPage;

            $show.text(`${showCount}`)
            $total.text(`${totalCount}`)
            $totalCount.text(totalCount)
            $totalCountText.html(window.translateByKey('offers', totalCount))
        }

        function scrollToRatingSortBlock(callback = null) {
            const $target = $('.rating-sort-block').first();

            if ($target.length) {
                const scrollAnimation = $('body, html').stop(true).animate({scrollTop: $target.offset().top}, 400);

                if (callback) {
                    scrollAnimation.promise().done(callback);
                }
            } else if (callback) {
                callback();
            }
        }


        // Нажатие на страницу в пагинации
        $('[data-exchanges-pagination-item]').click(e => {
            const target = $(e.target).closest('[data-exchanges-pagination-item]')[0].dataset.exchangesPaginationItem;
            let page = window.exchangesPage;

            if (target === 'prev') {
                page = page - 1 >= 1 ? page - 1 : 1;
            } else if (target === 'next') {
                const count = $('[data-exchanges-pagination-item][data-number]:visible').length;
                page = page + 1 <= count ? page + 1 : count;
            } else {
                page = +target;
            }

            const renderPage = () => {
                window.exchangesPage = page;

                $('[data-exchanges-pagination-item]').removeClass('active');
                $(`[data-exchanges-pagination-item="${window.exchangesPage}"]`).addClass('active');


                const start = (window.exchangesPage - 1) * exchangesPerPage;
                const end = start + exchangesPerPage;
                const enableIdsByPage = window.exchangesFilteredItems.slice(start, end);

                $(`[data-exchange-id]`).hide();

                enableIdsByPage.forEach(exchangeId => {
                    $(`[data-exchange-id="${exchangeId}"]`).show();
                })

                setMetaCounts();
                setOrderNumbers();
            };

            if (e.originalEvent) {
                scrollToRatingSortBlock(renderPage);
            } else {
                renderPage();
            }
        });

        // Открытие закрытие фильтра
        $('.rating-filter-inputs-item').on('click', '[data-filter-toggle]', function (e) {
            e.preventDefault();

            const $item = $(this).closest('.rating-filter-inputs-item');

            // Закрываем все, кроме текущего
            $('.rating-filter-inputs-item').not($item).removeClass('open');

            // Переключаем текущий
            $item.toggleClass('open');
        });


        // Закрываем все выпадающие фильтры по клику вне
        $(document).click(function (e) {
            if (!$(e.target).closest('.rating-filter-inputs-item').length) {
                $('.rating-filter-inputs-item').removeClass('open')
            }

            if (!$(e.target).closest('.rating-sort-dropdown.open').length) {
                $('.rating-sort-dropdown.open').removeClass('open')
            }
        })

        $('.rating-filter-inputs-item-options').on('click', '.checkbox-item', function (e) {
            e.preventDefault();
            const input = $(e.target).closest('label').find('input')[0];
            const checked = $(input).prop('checked')

            $(input).prop('checked', !checked)

            const data = getFormData();

            setPlaceHolders(data);
        })

        $('.rating-filter-buttons').on('click', '.rating-filter-buttons-icon', function (e) {
            $(e.target).closest('.rating-filter').toggleClass('open-filters')
        })

        $('#rating-filter-selected-tags').on('click', '[data-delete-rating-tag]', function (e) {
            const btn = $(e.target).closest('[data-delete-rating-tag]')[0];

            $(`[name="${btn.dataset.deleteRatingTag}"][value="${btn.dataset.deleteRatingTagValue}"]`).prop('checked', false);

            $(e.target).closest('.rating-filter-selected-tags-item')[0].remove();
            if (!$('.rating-filter-selected-tags-item').length) {
                $('#rating-filter-selected').removeClass('show')
            }

            const data = getFormData();

            setPlaceHolders(data);
            setOrderNumbers();

            $('[data-filter-submit]').click();
        })

        $('.rating-sort-dropdown-btn').on('click', function (e) {
            $(e.target).closest('.rating-sort-dropdown').toggleClass('open')
        })


        function setPlaceHolders(formData) {

            const values = {};
            let value = '';

            for (let field in formData) {
                if(Array.isArray(formData[field])) {
                    value = formData[field].map(value => {
                        return translatedHtml(value);
                    }).join(', ')
                } else {
                    value = translatedHtml(formData[field]);
                }

                values[field] = value;
            }

            $('[data-placeholder]').each(function (i, item) {
                const {placeholder:field, placeholderDefault} = item.dataset;

                $(item).html(values[field] ? values[field] : escapeHtml(placeholderDefault));
            });
        }

        function getFormData() {
            const form = $('#rating-filter-form');
            const formData = $(form).serializeArray();
            const data = {};

            formData.forEach(({name, value}) => {
                const input = $(`#rating-filter-form [name="${name}"]`)[0];
                const isArray = input.type === 'checkbox' ;

                if(data[name] === undefined) {
                    data[name] = isArray ? [value] : value;
                } else {
                    data[name].push(value);
                }
            });

            return data;
        }


        // Отправка форму фильтра
        $('.rating-filter-buttons').on('click', '[data-filter-submit]', function (e) {
            e.preventDefault();
            const formData = $(e.target).closest('form').serializeArray();
            const data = getFormData();
            const tags = [];

            formData.forEach(function (item) {
                item.name = item.name.replace('[]', '')

                tags.push(`
                    <div class="rating-filter-selected-tags-item">
                        ${translatedHtml(item.value)}
                        <svg data-delete-rating-tag="${item.name}" data-delete-rating-tag-value="${item.value}" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="20" rx="10" fill="#F5F7F8"/>
                            <rect x="6.71094" y="6" width="11" height="1" rx="0.5" transform="rotate(45 6.71094 6)" fill="#0457CA"/>
                            <rect x="6" y="13.7773" width="11" height="1" rx="0.5" transform="rotate(-45 6 13.7773)" fill="#0457CA"/>
                        </svg>
                    </div>
                `);
            })

            $('#rating-filter-selected-tags').html(tags.join(''));

            if (tags.join('')) {
                $('#rating-filter-selected').addClass('show');
            } else {
                $('#rating-filter-selected').removeClass('show')
            }

            const enableIds = [];

            exchanges.forEach(exchange => {
                let toShow = true;

                formData.forEach(item => {
                    switch (item.name) {
                        case 'byCountry':
                            if (!data.byCountry.includes(exchange.country)) {
                                toShow = false;
                            }
                            break;
                        case 'fiat':
                            if (data.fiat !== exchange.fields.fiat) {
                                toShow = false;
                            }
                            break;
                        case 'exchange_type':
                            if (!data.exchange_type.includes(exchange.fields.exchange_type)) {
                                toShow = false;
                            }
                            break;
                        case 'verification':
                            console.log(data.verification, exchange.fields.verification)
                            if (data.verification !== exchange.fields.verification) {
                                toShow = false;
                            }
                            break;
                        case 'p2p':
                            if (data.p2p !== exchange.fields.p2p) {
                                toShow = false;
                            }
                            break;
                        case 'cards':
                            const hasIntersection = exchange.fields.cards?.some(item => data.cards.includes(item));
                            if (!hasIntersection) {
                                toShow = false;
                            }
                            break;
                    }
                })

                if (toShow) enableIds.push(exchange.ID);
            })

            // Прячем все биржи
            $(`[data-exchange-id]`).hide()

            // Отбираем для первой страницы
            const enableIdsByPage = enableIds.slice(0, exchangesPerPage);

            // Показываем те, что нужно показать
            enableIdsByPage.forEach(exchangeId => {
                $(`[data-exchange-id="${exchangeId}"]`).show();
            })

            // $('[data-exchanges-pagination-item="1"]').click();

            window.exchangesPage = 1;
            window.exchangesFilteredItems = enableIds;

            const pagesCount = Math.ceil(enableIds.length / exchangesPerPage)

            if (pagesCount <= 1) {
                $('.exchanges-pagination-wrapper').hide();
            } else {
                $('.exchanges-pagination-wrapper').show();
            }

            $('[data-exchanges-pagination-item][data-number]').each((i, item) => {
                const n = +$(item).closest('[data-number]')[0].dataset.exchangesPaginationItem;

                if (n <= pagesCount) $(item).show();
                else $(item).hide();
            })

            $('[data-exchanges-pagination-item]').removeClass('active');
            $(`[data-exchanges-pagination-item="1"]`).addClass('active');

            setMetaCounts();
            setOrderNumbers();
        })

        // Сброс значеие формы
        $('#rating-filter-selected-reset').click(function (e) {
            $('#rating-filter-selected').removeClass('show')
            $('#rating-filter-selected-tags').html('');
            $('#rating-filter-form').trigger('reset');
            // $(`[data-exchange-id]`).show()
            $('[data-filter-submit]').click();

            const data = getFormData();
            setPlaceHolders(data);
            setMetaCounts();
            setOrderNumbers();
        })

        // Сортировка бирж
        $('[data-rating-sort]').on('click', function (e) {
            e.preventDefault();
            $(e.target).closest('.rating-sort-dropdown').removeClass('open');
            const direction = e.target.dataset.ratingSort;
            const text = $(e.target).text();
            $(e.target).closest('.rating-sort-dropdown').find('.rating-sort-dropdown-btn > span').text(text)

            const sortedExchanges = exchanges.filter(exchange => window.exchangesFilteredItems.includes(exchange.ID)).slice().sort((a, b) => {
                let valA, valB;

                switch (direction) {
                    case "reviews": // сортировка по среднему рейтингу из отзывов
                        valA = parseFloat(a.reviews_avg) || 0;
                        valB = parseFloat(b.reviews_avg) || 0;
                        break;

                    case "rating":
                        valA = a.ratingScore || 0;
                        valB = b.ratingScore || 0;
                        break;

                    case "volume": // объем торгов
                        valA = parseFloat(a.tradeVolume24HUsdNormalizedFloat) || 0;
                        valB = parseFloat(b.tradeVolume24HUsdNormalizedFloat) || 0;
                        break;

                    case "volumeChange": // изменение за 24ч (changePercent24H)
                        valA = parseFloat(a.changePercent24HFloat) || 0;
                        valB = parseFloat(b.changePercent24HFloat) || 0;
                        break;

                    case "year": // по возрастанию
                        valA = parseInt(a.foundationYear, 10) || 0;
                        valB = parseInt(b.foundationYear, 10) || 0;
                        return valA - valB;

                    case "tickers": // количество тикеров
                        valA = parseInt(a.tickersCount, 10) || 0;
                        valB = parseInt(b.tickersCount, 10) || 0;
                        break;

                    default:
                        return 0;
                }




                // всё кроме year сортируем по убыванию
                return valB - valA;
            })

            window.exchangesFilteredItems = sortedExchanges.map(exchange => exchange.ID);

            $('[data-exchanges-pagination-item="1"]').click();

            setMetaCounts();

            let sortedHtml = '';

            sortedExchanges.forEach(exchange => {
                sortedHtml += $(`[data-exchange-id="${exchange.ID}"]`).prop('outerHTML');
            })

            $('[data-rating-exchanges]').html(sortedHtml);

            setOrderNumbers();


            // console.log(direction);
        })

        // <div data-rating-sort="reviews">По отзывам</div>
        // <div data-rating-sort="rating">По рейтингу</div>
        // <div data-rating-sort="volume">По объему торгов</div>
        // <div data-rating-sort="volumeChange">По изменению объема торгов</div>
        // <div data-rating-sort="year">По году создания</div>
        // <div data-rating-sort="tickers">По количеству торговых пар</div>

        // await exchangesRating.updateDynamicsData();


    };

    if (document.readyState === 'complete') {
        init();
    } else {
        $(window).on('load', init);
    }
}(jQuery));
